// extracted by mini-css-extract-plugin
export default {"pageWrap":"sa-z","fullWidth":"ta-z","heading":"ua-z","fullBleed":"va-z","hidden":"wa-z"};